import { useState, useEffect, useContext } from "react";
import { useTracking } from "react-tracking";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from "react-csv";
import { MenuItem, Button, Divider, Text, Body1Strong, Title3, Caption1, FluentProvider, webLightTheme, Card, ProgressBar, ButtonProps } from "@fluentui/react-components";
import { BookTemplate20Regular, LinkSquare20Regular, ArrowClockwise20Regular, ArrowDownload20Regular, Save20Regular, Info20Filled, Dismiss16Regular } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import DialogBox from "../../../components/dialog/dialog.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { lightTheme, messageTheme, primaryIcon, secondaryIcon, overflowDivider, SubSectionResponsive, DynamicBoxingCSS, parentHome, dashboardTheme, BreadcrumbsBorder, wraperStyle } from "../../../styles/customStyles";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { Monitors_func } from "../../../api/devices/monitor/monitors_func";
import { useParams } from 'react-router-dom';
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { usePermissionStore } from "../../../Store/permissionStore";
import { InfoBar } from "../../../components/infoBar/infoBar.component";


export const Monitor_Attach_Detach = () => {
	const { trackEvent } = useTracking();
	const contextValue: any = useContext(GlobalContext);
	const [final_data, set_final_data]: any = useState(null);
	const [tableData, setTableData] = useState([]);
	const [leftOpen, setLeftOpen] = useState(false);
	const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
	const [overlayOpen, setOverlayOpen] = useState(false);
	const [searchVal, setSearchVal] = useState("");
	const [totalPages, setTotalPages] = useState(1);
	const [currentPageNo, setCurrentPageNo] = useState(1);
	const [totalRecords, setTotalRecords] = useState(0);
	const [exportData, setExportData] = useState([]);
	const [exportDetails, setExportDetails]: any = useState([]);
	const [toastMessage, setToastMessage] = useState('');
	const [errorToast, setErrorToast] = useState(false);
	const [messagebar1, setmessagebar1] = useState(false);
	const [messagebar2, setmessagebar2] = useState(false);
	const [messagebar3, setMessagebar3] = useState(false);
	const [isSaveEnabled, setSaveEnabled] = useState(false);
	const [isRefresh, setRefresh]: any = useState(false);
	const [isToast, setIsToast] = useState(false);
	const [refreshToast, setRefreshToast]: any = useState(false);
	const [rowID, setRowID]: any = useState(null);
	const [deviceCnt, setDeviceCnt]: any = useState(0);
	const [groupDeviceCnt, setGroupDeviceCnt]: any = useState({});
	const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
	const [defaultSelectedRows, setDefaultSelectedRows]: any = useState([]);
	const [previousSelectedGroups, setPreviousSelectedGroups]: any = useState([]);
	const [showMessage, setShowMessage] = useState(false);
	const [tracker, setTracker] = useState(false);
	const [userActivityData, setUserActivityData] = useState({});
	const [isProgressLoading, setProgressLoading] = useState(false);
	const [loading, setLoading] = useState(true);
	const [exportBtnClicked, setExportBtnClicked] = useState(false);
	const { permissions } = usePermissionStore();

	var automationType = contextValue.automationDetails.automationType;
	var attachmentArr: any = [];
	var detachmentArr: any = [];

	const [allAttachmentGrp, setAllAttachmentGrp] = useState(['']);
	const [allDetachmentGrp, setAllDetachmentGrp] = useState(['']);
	const [alertId, setAlertId]: any = useState()
	const { id } = useParams();
	var tenantName = contextValue.tenantName;

	const handleSaveAlert = () => {
		if (!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
			if (previousSelectedGroups.length == 0) {
				detachmentArr = [];
				// setDetachmentGrp(detachmentArr);
				setAllDetachmentGrp(detachmentArr);
			} else {
				detachmentArr = contextValue.selectedRowIdInTable?.filter((val: any) => val != 'All Devices')
				// setDetachmentGrp(detachmentArr);
				setAllDetachmentGrp(detachmentArr);
			}
			attachmentArr = ['All Devices'];
			// setAttachmentGrp(attachmentArr);
			setAllAttachmentGrp(attachmentArr);
		} else if (previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
			detachmentArr = ['All Devices'];
			// setDetachmentGrp(detachmentArr);
			setAllDetachmentGrp(detachmentArr);

			attachmentArr = contextValue.selectedRowIdInTable?.filter((val: any) => !previousSelectedGroups.includes(val));
			// setAttachmentGrp(attachmentArr);
			setAllAttachmentGrp(attachmentArr);

		} else {
			console.log("Previous selected values", previousSelectedGroups)
			console.log("CURRENT SELECTED VALUES", contextValue.selectedRowIdInTable)
			detachmentArr = previousSelectedGroups?.filter((val: any) => !contextValue.selectedRowIdInTable.includes(val));
			// setDetachmentGrp(detachmentArr);
			setAllDetachmentGrp(detachmentArr);

			attachmentArr = contextValue.selectedRowIdInTable?.filter((val: any) => !previousSelectedGroups.includes(val));
			// setAttachmentGrp(attachmentArr);
			setAllAttachmentGrp(attachmentArr);
		}
		setAlertId(id)
		setProgressLoading(true)
		setSaveBtnClicked(true)
	}


	useEffect(() => {
		console.log("tempGrp=", allAttachmentGrp);
		console.log("ATTACHMENTVAL Group", allAttachmentGrp)
		console.log("DETTACHMENT Group", allDetachmentGrp)
	}, [allAttachmentGrp, allDetachmentGrp]);

	const [isPopoverOpenEnable, setisPopoverOpenEnable] = useState(false);
	const handle = useFullScreenHandle();

	const truncateSelectedDevices = (selectedDevices: string[]) => {
		const MAX_DISPLAY = 3;
		if (selectedDevices?.length > MAX_DISPLAY) {
			const truncatedList = selectedDevices.slice(0, MAX_DISPLAY);
			truncatedList.push(`${selectedDevices.length - MAX_DISPLAY}+ more`);
			return truncatedList;
		}
		return selectedDevices;
	};

	var menuItems: any = [];

	menuItems.push
		(
			<FluentProvider theme={lightTheme}>
				<MenuItem
					icon={
						<Stack horizontal tokens={{ childrenGap: 40 }}>
							<StackItem><Text></Text></StackItem>
							<StackItem> <LinkSquare20Regular {...primaryIcon} /> </StackItem>
						</Stack>}>
					<Stack tokens={{ childrenGap: 30 }} horizontal>
						<StackItem><Text></Text></StackItem>
						<StackItem> <Caption1> Assignment </Caption1> </StackItem>
						{/* <StackItem> <Stack tokens={{ childrenGap: 80 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem> */}
						{/* SPACING IN INLINE SIDEBAR */}
					</Stack>
				</MenuItem>
			</FluentProvider>
		);

	menuItems.push
		(
			<MenuItem
				icon={
					<Stack horizontal tokens={{ childrenGap: 40 }}>
						<StackItem><Text></Text></StackItem>
						<StackItem> <BookTemplate20Regular {...primaryIcon} /> </StackItem>
					</Stack>}>
				<Stack tokens={{ childrenGap: 30 }} horizontal>
					<StackItem><Text></Text></StackItem>
					<StackItem> <Caption1> Audit Log </Caption1> </StackItem>
				</Stack>
			</MenuItem>
		);
	//inline side menu content code ends here
	//data table column name code starts here
	var columns = [
		{ key: "group_name", label: <Body1Strong> Group Name </Body1Strong> },
		{ key: "device_cnt", label: <Body1Strong> Count of Devices </Body1Strong> },
	];
	//data table column name code ends here
	// overflow set contents code starts here
	var overFlowComponent = {
		data: (
			<>
				<StackItem>
					<DialogBox
						headerButton={
							<Button shape="circular" appearance="transparent" size="small"
								disabled={isSaveEnabled ? false : true} >
								<Stack tokens={{ childrenGap: 5 }} horizontal>
									<StackItem> {isSaveEnabled ? (<Save20Regular {...primaryIcon} />) : (<Save20Regular {...secondaryIcon} />)} </StackItem>
									<StackItem> <Caption1> Save </Caption1> </StackItem>
								</Stack>
							</Button>
						}
						// console.log("previousSelectedGroups=",previousSelectedGroups," checked=",contextValue.selectedRowIdInTable," attached=",attachmentArr," unattached=",detachmentArr);
						// content= {(!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) ?  "Please confirm your decision to proceed with this change. The policy will be assigned to 'All devices'." : (previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.length == 0) ?  "Please confirm your decision to proceed with this change. The policy will be removed from 'All devices'." : `This change will be pushed to all connected devices that belong to the following groups:\r\n${contextValue.selectedRowIdInTable.join(",")}`}
						content={
							<>
								<Stack tokens={{ childrenGap: 5 }}>
									<StackItem>
										{
											(!previousSelectedGroups?.includes('All Devices') && contextValue.selectedRowIdInTable?.includes('All Devices'))
												? "Are you sure you want to enable the alerts for all devices?"
												:
												(previousSelectedGroups?.length > 0 && contextValue.selectedRowIdInTable?.length === 0) ? `Are you sure you want to detach the alert?`
													: `Are you sure you want to enable the alerts for the selected device classifications
                        :\r\n${truncateSelectedDevices(contextValue.selectedRowIdInTable?.filter((val: any) => !previousSelectedGroups?.includes(val)))?.join(', ')}`
										}
									</StackItem>
								</Stack>

							</>
						}

						footer={
							<>
								<Stack horizontal tokens={{ childrenGap: 10 }}>
									<StackItem> <Button shape="circular" appearance="primary" onClick={handleSaveAlert} size="small"> Confirm </Button> </StackItem>
									<StackItem> <Button shape="circular" size="small" onClick={() => { setmessagebar1(false); }}> Cancel </Button> </StackItem>
								</Stack>
							</>
						}
					/>
				</StackItem>

				<StackItem><Divider vertical /></StackItem>

				<StackItem>
					<Button shape="circular" appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setRefresh(true); setLoading(true); }}>
						<Stack tokens={{ childrenGap: 5 }} horizontal>
							<StackItem> <ArrowClockwise20Regular {...primaryIcon} /> </StackItem>
							<StackItem> <Caption1> Refresh </Caption1> </StackItem>
						</Stack>
					</Button>
				</StackItem>

				{/* <StackItem>
					<CSVLink id="csv-export-link" data={exportData} filename={`${contextValue.automationDetails.automationName}_${automationType}.csv`}>
						<Button shape="circular" appearance="subtle" size="small" onClick={() => { userActivity('Export', `{"summary":"Configured groups list exported"}`); }}>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem>{loading?<ArrowDownload20Regular {...secondaryIcon} />:<ArrowDownload20Regular {...primaryIcon} />} </StackItem>
								<StackItem> <Caption1> Export </Caption1> </StackItem>
							</Stack>
						</Button>
					</CSVLink>
				</StackItem> */}
				{permissions.includes("monitor_Fullaccess") || permissions.includes("all") ?
					<StackItem>
						<CSVLink id="csv-export-link" data={exportData} filename={`${contextValue.automationDetails.automationName}_${automationType}.csv`}>
						</CSVLink>
						<Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); /*userActivity('Export', `{"summary":"Configured groups list exported"}`);*/ }}>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
								<StackItem> <Caption1> Export </Caption1> </StackItem>
							</Stack>
						</Button>
					</StackItem>
					:
					<StackItem>
						<Button shape="circular" appearance="subtle" size="small" disabled>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
								<StackItem> <Caption1> Export </Caption1> </StackItem>
							</Stack>
						</Button>
					</StackItem>
				}

				<StackItem grow shrink>
					<Stack horizontalAlign="end">
						<StackItem grow shrink>
							<FullScreenButton handle={handle} />
						</StackItem>
					</Stack>
				</StackItem>
			</>
		),
	};

	useEffect(() => {
		var tempExportData: any = [];
		tempExportData.push({
			'Group Name': 'All Devices',
			'Device Count': deviceCnt,
			'Status': previousSelectedGroups.includes('All Devices') ? 'Attached' : 'Not Attached'
		});

		exportDetails?.length > 0 && exportDetails.map((val: any) => {
			tempExportData.push({
				'Group Name': val.classificationName,
				'Device Count': groupDeviceCnt[`${val.classificationName}`],
				'Status': previousSelectedGroups.includes(val.classificationName) ? 'Attached' : 'Not Attached'
			});
		});
		exportDetails?.length > 0 && setExportData(tempExportData);
	}, [exportDetails]);

	useEffect(() => {
		exportData.length > 0 && document.getElementById('csv-export-link')?.click();
	}, [exportData]);

	// overflow set contents code ends here

	var tempTableData: any = [];
	useEffect
		(() => {
			setmessagebar2(false);
			var defaultSelectedIds: any = [];
			console.log("previousSelectedGroups=", previousSelectedGroups);
			{
				permissions.includes("all") || permissions.includes("monitor_Fullaccess") ?
					deviceCnt > 0 && tempTableData.push({
						id: 'All Devices',
						group_name: { label: <Caption1> All Devices </Caption1>, icon: "", id: 1, },
						device_cnt: { label: <Caption1> {deviceCnt} </Caption1>, icon: "", status: "", },
					})
					:
					deviceCnt > 0 && tempTableData.push({
						id: 'All Devices',
						checkbox: "hide",
						group_name: { label: <Caption1> All Devices </Caption1>, icon: "", id: 1, },
						device_cnt: { label: <Caption1> {deviceCnt} </Caption1>, icon: "", status: "", },
					});
			}
			previousSelectedGroups?.includes('All Devices') && defaultSelectedIds.push(0);
			console.log("tempTableData=", tempTableData);

			final_data !== undefined && final_data !== null
				? final_data?.map((val: any, i: any) => {
					previousSelectedGroups.includes(val.classificationName) && defaultSelectedIds.push(i + 1);

					{
						permissions.includes("monitor_Fullaccess") || permissions.includes("all") ?
							tempTableData.push({
								id: val.classificationName,
								checkbox: contextValue.selectedRowIdInTable.includes("All Devices") ? "hide" : "show",
								group_name: { label: <Caption1> {val.classificationName} </Caption1>, icon: "", id: `${i}` },
								device_cnt: { label: <Caption1> {groupDeviceCnt[`${val.classificationName}`]} </Caption1>, icon: "", status: "" }
							})
							:
							tempTableData.push({
								id: val.classificationName,
								checkbox: "hide",
								group_name: { label: <Caption1> {val.classificationName} </Caption1>, icon: "", id: `${i}` },
								device_cnt: { label: <Caption1> {groupDeviceCnt[`${val.classificationName}`]} </Caption1>, icon: "", status: "" }
							})
					}
				}) : (tempTableData = []);

			setDefaultSelectedRows(defaultSelectedIds);
			tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
			setTimeout(() => {
				final_data !== undefined && final_data !== null && setLoading(false);
			}, 500);
		}, [final_data, groupDeviceCnt, previousSelectedGroups, contextValue.selectedRowIdInTable, permissions]);
	// data table values append code ends here

	useEffect(() => {
		contextValue.setSelectedRowIdInTable([]);
	}, []);

	useEffect(() => {
		contextValue.setSelectedRowIdInTable(previousSelectedGroups);
	}, [previousSelectedGroups]);

	useEffect(() => {
		var newCheckedVal = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
		console.log("checked=", contextValue.selectedRowIdInTable, "previousSelectedGroups=", previousSelectedGroups, "newCheckedVal", newCheckedVal);
		(newCheckedVal?.length > 0 || (previousSelectedGroups?.length > 0 && contextValue.selectedRowIdInTable?.length >= 0 && JSON.stringify(previousSelectedGroups) !== JSON.stringify(contextValue.selectedRowIdInTable))) ? setSaveEnabled(true) : setSaveEnabled(false);
	}, [contextValue.selectedRowIdInTable]);

	// const userActivity = (action: String, activity: String, status: any = 'Success') => {
	// 	setUserActivityData({ pageName: 'Remediation assignment', moduleName: "Devices", action: action, time: Math.floor(Date.now() / 1000), activity: activity, status: status });
	// 	setTracker(false);
	// }

	useEffect(() => {
		var detachmentExportArr = [];
		var attachmentExportArr = [];

		if (!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
			if (previousSelectedGroups.length == 0) {
				detachmentExportArr = [];
			}
			else {
				detachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => val != 'All Devices')
			}
			attachmentExportArr = ['All Devices'];
		}
		else if (previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
			detachmentExportArr = ['All Devices'];
			attachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
		}
		else {
			detachmentExportArr = previousSelectedGroups.filter((val: any) => !contextValue.selectedRowIdInTable.includes(val));
			attachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
		}

		var summary = '';
		if (attachmentExportArr.length > 0 && detachmentExportArr.length > 0) {
			summary = `${contextValue.automationDetails.automationName} remediation has attached to ${attachmentExportArr.length} configured ${attachmentExportArr.length > 1 ? 'groups' : 'group'} and detached from ${detachmentExportArr.length} configured ${detachmentExportArr.length > 1 ? 'groups' : 'group'}`;
		} else if (attachmentExportArr.length > 0 && detachmentExportArr.length < 1) {
			summary = `${contextValue.automationDetails.automationName} remediation has attached to ${attachmentExportArr.length} configured ${attachmentExportArr.length > 1 ? 'groups' : 'group'}`;
		} else if (attachmentExportArr.length < 1 && detachmentExportArr.length > 0) {
			summary = `${contextValue.automationDetails.automationName} remediation has detached from ${detachmentExportArr.length} configured ${detachmentExportArr.length > 1 ? 'groups' : 'group'}`;
		}

		// userActivity('Add', `{"remediationName":"${contextValue.automationDetails.automationName}","attachedGroups":"${attachmentExportArr}","detachedGroups":"${detachmentExportArr}","summary":"${summary}"}`);
		saveBtnClicked && setProgressLoading(false)
	}, [saveBtnClicked]);

	useEffect(() => {
		var detachmentVal = allDetachmentGrp.length > 0 ? allDetachmentGrp[0] : 0;
		var attachmentVal = allAttachmentGrp.length > 0 ? allAttachmentGrp[0] : 0;

		(messagebar2 || errorToast) && detachmentVal === 0 && attachmentVal === 0 && setProgressLoading(false);
	}, [messagebar2, errorToast]);



	return (
		<>
			<FullScreen handle={handle} className="fullScreenBackgroundColor">
				<StackItem grow shrink style={BreadcrumbsBorder}>
					<Stack tokens={{ childrenGap: 10 }} horizontal>
						<StackItem grow shrink>
							<Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
								<StackItem><Text></Text></StackItem>
								<StackItem grow shrink>
									{/* <Breadcrumbs pageName="Devices" subPageName="Monitor" subPageLink="/manage/devices/monitor" />  */}
									<Breadcrumbs
										items={[
										{ name: "Manage", link: "/home" },
										{ name: "Devices", link: "/manage/devices/overview" },
										{ name: "Monitor", link: "/manage/devices/monitor" },
										{ name: (contextValue?.alertDetails?.alertName), link: "#", isData: true },
										{ name: "Assignment", link: "#" }
										]} 
									/>
								</StackItem>
							</Stack>
						</StackItem>
						{/* <StackItem grow shrink>
							<Stack horizontalAlign="end">
								<StackItem grow shrink>
									<FullScreenButton handle={handle} />
								</StackItem>
							</Stack>
						</StackItem> */}
					</Stack>
				</StackItem>
				<Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
					<StackItem style={DynamicBoxingCSS}>
						{/* pages code starts here */}
						<Stack style={DynamicBoxingCSS}>
							{/* <StackItem> <Text> <Breadcrumbs pageName="Devices" subPageName="Remediations" subPageLink="/manage/devices/remediation" /> </Text> </StackItem> */}
							<Stack tokens={{ childrenGap: 25 }} horizontal>
								<StackItem><Text></Text></StackItem>
								<StackItem>
									<FluentProvider theme={dashboardTheme}>
										{/* <Title3> {contextValue?.alertDetails?.alertName} | Assignment </Title3> */}
									</FluentProvider>
								</StackItem>
								{/* <Button shape="circular" size="small" appearance="subtle"> <ArrowMaximize16Regular /> </Button> */}
							</Stack>
							<FluentProvider style={parentHome} theme={dashboardTheme}>
								<Stack style={parentHome} horizontal >
									{/* SPACING BETWEEN INLINE AND PAGE */}
									<SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
									<StackItem style={DynamicBoxingCSS}>
										<Stack>{isProgressLoading && <ProgressBar />}</Stack>
										<Stack className={isProgressLoading ? 'disabled-opacity' : ''} style={parentHome} tokens={{ childrenGap: 10 }}>
											<StackItem>
												<OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
												<Divider />
											</StackItem>
											<StackItem style={wraperStyle}>
												<Stack horizontal horizontalAlign="space-between">
													<StackItem>
													<SearchBar searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading} />
													</StackItem>
													{tableData.length > 0 &&
														<StackItem>
															<Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} defaultSelected={defaultSelectedRows} />
														</StackItem>}
												</Stack>
												<InfoBar showSpaces={true} title={"If you choose the option 'All devices' The policy will be applied universally to all devices and will become detached from Devices groups."} />
												{tableData.length > 0 &&
													<Stack horizontal enableScopedSelectors horizontalAlign="space-between">
														<StackItem>
															<Caption1> Showing {(currentPageNo - 1) * 50 + 1} to {currentPageNo * 50 > totalRecords ? totalRecords : currentPageNo * 50} of {totalRecords} Records </Caption1>
														</StackItem>

													</Stack>
												}
											</StackItem>

											<Monitors_func
												searchVal={searchVal}
												tenant={tenantName}
												setExportBtnClicked={setExportBtnClicked}
												exportBtnClicked={exportBtnClicked}
												data={final_data}
												func={set_final_data}
												pageNo={(currentPageNo - 1) * 50}
												setTotalPages={setTotalPages}
												setTotalRecords={setTotalRecords}
												isRefresh={isRefresh}
												setRefresh={setRefresh}
												setRefreshToast={setRefreshToast}
												setDeviceCnt={setDeviceCnt}
												saveBtnClicked={saveBtnClicked}
												setSaveBtnClicked={setSaveBtnClicked}
												groupDeviceCnt={groupDeviceCnt}
												setGroupDeviceCnt={setGroupDeviceCnt}
												setPreviousSelectedGroups={setPreviousSelectedGroups}
												setExportDetails={setExportDetails}
												alertId={id}
												setProgressLoading={setProgressLoading}
												isProgressLoading={isProgressLoading}
												alertName={contextValue?.alertDetails?.alertName}
												setToastMessage={setToastMessage}
												setErrorToast={setErrorToast}
												setmessagebar2={setmessagebar2}
												setMessagebar3={setMessagebar3}
											/>

											{/* {tableData.length > 0 && <DataTable tableData={tableData} columns={columns} defaultSelected={defaultSelectedRows} />} */}
											{loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} defaultSelected={defaultSelectedRows} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
											{/* {tracker && <Activity_log_func data={userActivityData} setTracker={setTracker} type="insertLog" />} */}
										</Stack>
									</StackItem>
								</Stack>
							</FluentProvider>
						</Stack>
						<StackItem>
							{
								messagebar1 &&
								<ToastComponent
									setmessagebar={setmessagebar1}
									toastIntent="warning"
									position="top"
									title="Please confirm your decision to proceed with change. the policy will be assigned to 'All devices'."
									footer={
										<>
											{/* <Button shape="circular" appearance="primary" onClick={handleBothSetMessage}> Confirm </Button> */}
											<Button shape="circular" onClick={() => { setmessagebar1(false); }}> Cancel </Button>
										</>
									}
								/>
							}
						</StackItem>
						<OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData="Census" />
					</StackItem>

					{messagebar2 &&
						<ToastComponent
							setmessagebar={setMessagebar3}
							toastIntent="success"
							position="top-end"
							title="Success"
							message={toastMessage}
							footer=""
						/>
					}
					{messagebar3 &&
						<ToastComponent
							setmessagebar={setmessagebar2}
							toastIntent="success"
							position="top-end"
							title="Success"
							message={toastMessage}
							footer=""
						/>
					}
					{refreshToast &&
						<ToastComponent
							setmessagebar={setIsToast}
							isToastEnabled={refreshToast}
							toastIntent="success"
							position="top-end"
							title="Success"
							message={'Data Table Refreshed'}
							footer=""
						/>
					}

					{errorToast &&
						<ToastComponent
							setmessagebar={setErrorToast}
							toastIntent="error"
							position="top-end"
							title="Failed"
							message={toastMessage}
							footer=""
							setProgressLoading={setProgressLoading}
						/>
					}
					<StackItem><Text></Text></StackItem>
				</Stack>
			</FullScreen>
		</>
	);
};